import Custom100ControlBatchDetail from '../../components/Custom100ControlBatchDetail';

const C100ControlBatchDetail = () => {
  return <Custom100ControlBatchDetail />;
};

export default C100ControlBatchDetail;
